import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  containerBox: {
    marginBottom: '0.5rem',
    borderRadius: '30px',
    display: 'flex',
    alignItems: 'center',
    height: '1.5vw',
    [theme.breakpoints.down('xxl')]: {
      height: '1vw'
    },
    [theme.breakpoints.down('xl')]: {
      height: '1.5vw'
    }
  },
  stack: {
    [theme.breakpoints.up('xxl')]: {
      marginTop: '1vw !important'
    }
  },
  labelText: {
    color: theme.vars.palette.text.primary,
    fontSize: '0.7rem',
    [theme.breakpoints.down('xxl')]: {
      fontSize: '0.5rem'
    },
    [theme.breakpoints.down('xl')]: {
      fontSize: '0.75rem'
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '0.6rem'
    }
  },
  totalText: {
    color: theme.vars.palette.text.primary,
    fontSize: '0.9rem',
    fontWeight: 600,
    [theme.breakpoints.down('xxl')]: {
      fontSize: '0.6rem'
    },
    [theme.breakpoints.down('xl')]: {
      fontSize: '1rem'
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '0.7rem'
    }
  },
  colorBox: {
    width: '0.5rem',
    height: '100%',
    borderRadius: '4px',
    marginRight: '0.5rem',
    [theme.breakpoints.down('md')]: {
      height: '1.75rem'
    },
    [theme.breakpoints.down('md')]: {
      height: '1rem'
    }
  }
}));

export default useStyles;
